/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC721ManagedPrefixedCollection,
  ERC721ManagedPrefixedCollectionInterface,
} from "../ERC721ManagedPrefixedCollection";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "string",
            name: "placeholderURI",
            type: "string",
          },
          {
            internalType: "string",
            name: "tokenURIPrefix",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "initialHolders",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "initialAmounts",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "maxSupply",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "defaultRoyaltyAddress",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "defaultRoyaltyBps",
            type: "uint16",
          },
          {
            internalType: "address",
            name: "trustedForwarder",
            type: "address",
          },
        ],
        internalType: "struct ERC721ManagedPrefixedCollection.Config",
        name: "config",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "bps",
        type: "uint16",
      },
    ],
    name: "DefaultRoyaltySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "TokenRoyaltyRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "bps",
        type: "uint16",
      },
    ],
    name: "TokenRoyaltySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "_trustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultRoyalty",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "bps",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "freezeMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "freezeTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_senderBalance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getRaribleV2Royalties",
    outputs: [
      {
        components: [
          {
            internalType: "address payable",
            name: "account",
            type: "address",
          },
          {
            internalType: "uint96",
            name: "value",
            type: "uint96",
          },
        ],
        internalType: "struct LibPart.Part[]",
        name: "result",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokenRoyaltiesCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getTokenRoyaltyByIndex",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "bps",
            type: "uint16",
          },
        ],
        internalType: "struct IEIP2981RoyaltyOverride.TokenRoyaltyConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "string",
            name: "placeholderURI",
            type: "string",
          },
          {
            internalType: "string",
            name: "tokenURIPrefix",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "initialHolders",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "initialAmounts",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "maxSupply",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "defaultRoyaltyAddress",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "defaultRoyaltyBps",
            type: "uint16",
          },
          {
            internalType: "address",
            name: "trustedForwarder",
            type: "address",
          },
        ],
        internalType: "struct ERC721ManagedPrefixedCollection.Config",
        name: "config",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "deployer",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "managementPowerRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupplyFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "mintByOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "placeholderURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revokeManagementPower",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newValue",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "bps",
            type: "uint16",
          },
        ],
        internalType: "struct IEIP2981RoyaltyOverride.TokenRoyalty",
        name: "royalty",
        type: "tuple",
      },
    ],
    name: "setDefaultRoyalty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newValue",
        type: "string",
      },
    ],
    name: "setPlaceholderURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "bps",
            type: "uint16",
          },
        ],
        internalType: "struct IEIP2981RoyaltyOverride.TokenRoyaltyConfig[]",
        name: "royaltyConfigs",
        type: "tuple[]",
      },
    ],
    name: "setTokenRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newValue",
        type: "string",
      },
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newValue",
        type: "string",
      },
    ],
    name: "setTokenURISuffix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder",
        type: "address",
      },
    ],
    name: "setTrustedForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenURIFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenURIPrefix",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenURISuffix",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "transferFromBulk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "transferFromBulk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ERC721ManagedPrefixedCollection__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    config: {
      name: string;
      symbol: string;
      contractURI: string;
      placeholderURI: string;
      tokenURIPrefix: string;
      initialHolders: string[];
      initialAmounts: BigNumberish[];
      maxSupply: BigNumberish;
      defaultRoyaltyAddress: string;
      defaultRoyaltyBps: BigNumberish;
      trustedForwarder: string;
    },
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721ManagedPrefixedCollection> {
    return super.deploy(
      config,
      overrides || {}
    ) as Promise<ERC721ManagedPrefixedCollection>;
  }
  getDeployTransaction(
    config: {
      name: string;
      symbol: string;
      contractURI: string;
      placeholderURI: string;
      tokenURIPrefix: string;
      initialHolders: string[];
      initialAmounts: BigNumberish[];
      maxSupply: BigNumberish;
      defaultRoyaltyAddress: string;
      defaultRoyaltyBps: BigNumberish;
      trustedForwarder: string;
    },
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(config, overrides || {});
  }
  attach(address: string): ERC721ManagedPrefixedCollection {
    return super.attach(address) as ERC721ManagedPrefixedCollection;
  }
  connect(signer: Signer): ERC721ManagedPrefixedCollection__factory {
    return super.connect(signer) as ERC721ManagedPrefixedCollection__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721ManagedPrefixedCollectionInterface {
    return new utils.Interface(
      _abi
    ) as ERC721ManagedPrefixedCollectionInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721ManagedPrefixedCollection {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC721ManagedPrefixedCollection;
  }
}
